module.exports = __webpack_public_path__ + "static/img/knowledgethis.886533d4.png";